const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "WhatsApp connection deleted sucessfully!",
          transferSuccess:
            "Transfer completed. Tickets moved: {{tickets}}. Schedules moved: {{schedules}}.",
        },
        transferModal: {
          button: "Transfer tickets",
          title: "Transfer tickets and schedules",
          message:
            "Choose the source and destination connections. This migration updates the connection IDs on tickets and schedules.",
          sourceLabel: "Source connection",
          targetLabel: "Destination connection",
          helper:
            "You can transfer to any other connection in the same company.",
          confirm: "Transfer",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        buttons: {
          add: "Add WhatsApp",
          editConnection: "Edit connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit WhatsApp",
        },
        form: {
          name: "Name",
          provider: "Provider",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "WhatsApp saved successfully.",
        errorGreetingMessage:
          "Greeting message is required when two or more queues are selected.",
        queueRequired: "A queue must be selected for message import.",
        vacationDatesRequired:
          "Start and end dates for collective vacation are required when vacation message is filled.",
        invalidDates:
          "Start date cannot be later than the end date for collective vacation.",
        errorExpiresInactiveMessage:
          "Inactivity closure message is required when ticket expiration time is configured.",
        errorTimeInactiveMessage:
          "Time for inactivity warning is required when inactivity message is filled.",
        npsDisabled:
          "NPS is disabled in company settings. Configure at: Settings > Company",
        queueSelected: "Queues selected. Prompt and Integrations are disabled.",
        promptSelected:
          "Prompt selected. Queues and Integrations are disabled.",
        integrationSelected:
          "Integration selected. Queues and Prompt are disabled.",
        importInfo:
          "The connection will be restarted to import messages. Please wait for the reconnection and import process.",
        status: {
          connected: "Connected",
          opening: "Opening",
          qrcode: "QR Code",
          disconnected: "Disconnected",
          timeout: "Timeout",
          pairing: "Pairing",
          destroyed: "Destroyed",
        },
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        errors: {
          numberWithDDI:
            "Include the country code. Use 55 for Brazil (e.g., 5511999999999) or the appropriate code (e.g., +12125551234)",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
          closeTicket: "Close Ticket",
          expiresTicket: "Close open chats after x minutes",
          whenExpiresTicket: "Close when last message is",
          whenExpiresTicketAny: "Any message",
          whenExpiresTicketAgent: "Agent message only",
          expiresInactiveMessage: "Inactivity close message",
          timeInactiveMessage: "Send inactivity warning after x minutes",
          inactiveMessage: "Inactivity message",
          queueType: "Menu type",
          message: "Response message",
          queue: "Transfer queue",
          integration: "Integration",
          file: "File list",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          spyTicket: "Spy ticket",
          allowSendAudio: "Allow audio sending",
          allowSendMedia: "Allow media sending",
          allowViewAllClosedTickets: "View all closed tickets (in my queues)",
          allowContacts: "Allow Contacts",
          allowAutomations: "Allow Automations",
          allowCampaigns: "Allow Campaigns",
          allowAgendaCare: "Allow AgendaCare",
          allowOdontoCare: "Allow OdontoCare",
          allowPetCare: "Allow PetCare 360",
          allowCallcenterUser: "Allow Callcenter User",
          allowCallcenterAdmin: "Allow Callcenter Admin",
          allowCashierPdv: "Allow Cashier PDV",
          allowPdv: "Allow PDV",
          allowErpPhone: "Allow ERP-Phone",
          allowViewAllSchedules: "View all schedules",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
        noQueue: "No queue",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        noOptions: "No user found with this name",
        attachDocument: "Attach document (private)",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          queues: "Queues",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
          files: "File manager",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      chatIndex: {
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          cancel: "Cancel",
          save: "Save",
        },
        all: "All",
        chats: "Chats",
        groups: "Groups",
        createGroup: "Create group",
        createDirect: "New chat",
        createGroupShort: "New group",
        directTooltip: "Create direct chat",
        groupDialogTitle: "Create internal chat group",
        groupUsersRequired: "Select at least 2 agents to create the group.",
        groupNameRequired: "Enter the group name.",
        directCreateSuccess: "Chat created successfully.",
        groupCreateSuccess: "Chat group created successfully.",
        creating: "Creating...",
        cancel: "Cancel",
        save: "Save",
        deleteGroup: "Delete group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        delete: "Delete",
      },
      chatList: {
        noMessages: "No messages",
        now: "Now",
        minutesAgo: "{{count}} min ago",
        hoursAgo: "{{count}} h ago",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        deleteChat: "Delete chat",
        deleteChatConfirm: "Are you sure you want to delete this chat?",
        detailsTitle: "Chat details",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat",
        createNewChat: "New chat",
        searchUser: "Search user",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
      },
      chatMessages: {
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        reply: "Reply",
        deleted: "Message deleted",
        deletedAdmin: "Message deleted (visible to admin)",
        replyingTo: "Replying to",
        forwarded: "Forwarded",
        clickToGoToOriginal: "Click to go to original message",
      },
      notifications: {
        noTickets: "No notifications.",
      },
      quickMessages: {
        dialog: {
          visibility: "Visibility",
          visibilityUserSpecific: "User Specific",
          visibilityAdminPrivate: "Only me (Admin)",
          visibilityGlobal: "Everyone",
          assignedUser: "Assigned User",
          none: "None",
        },
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
        },
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          options: {
            enabled: "Enabled",
            disabled: "Disabled",
            updating: "Updating...",
            operationUpdated: "Operation updated successfully.",
            asaasTab: "ASAAS",
            asaasTokenLabel: "Asaas Token",
            asaasTokenSaved: "Token saved.",
            asaasTokenNotConfigured: "Token not configured.",
            asaasTokenSaveError: "Could not save Asaas token.",
            asaasEnvLabel: "Asaas Environment",
            asaasEnvProduction: "Production (https://api.asaas.com/)",
            asaasEnvSandbox: "Sandbox (https://api-sandbox.asaas.com/)",
            asaasEnvSaved: "Environment saved: {{env}}.",
            asaasEnvNotConfigured: "Environment not configured.",
            asaasEnvSaveError: "Could not save Asaas environment.",
            transferredTicketStatus: "Status when transferring with user",
            statusOpen: "Open",
            statusPending: "Pending",
            statusClosed: "Closed",
            randomizeOnManualTransfer: "Randomize on manual transfer",
            copyContactSettingsTab: "Contact copy prefix settings",
            copyContactPrefix: "Contact copy prefix",
            copyContactPrefixPlaceholder: "Ex: CL_",
            removeCountryCodeOnCopy: "Remove country code when copying",
            removeAreaCodeOnCopy: "Remove area code when copying",
            remove9thDigitOnCopy: "Remove 9th digit when copying",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
        transferLabel: "Select the connection that will receive the tickets",
        transferHelper:
          "Tickets will keep their current queues after the transfer.",
        transferUnavailable:
          "No other connection for this channel is available. Create a new one before deleting.",
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_WAPP_PAUSED:
          "WhatsApp session is paused. Resume the connection to send messages.",
        ERR_CLOUD_API_TOKEN_INVALID:
          "Official API token is invalid or expired. Update the connection token.",
        ERR_CLOUD_API_MISSING_CONFIG:
          "Cloud API connection is incomplete. Update the connection settings.",
        ERR_SENDING_CLOUD_API_TEMPLATE:
          "Failed to send official API template message. Check the selected template.",
        ERR_TRANSFER_WHATSAPP_REQUIRED:
          "Select a destination connection to transfer tickets before deleting this one.",
        ERR_TRANSFER_WHATSAPP_INVALID_TARGET:
          "Invalid connection selected for transfer.",
        ERR_TRANSFER_WHATSAPP_TARGET_IN_REMOVAL:
          "The selected transfer connection is also scheduled for removal. Choose another.",
        ERR_TRANSFER_WHATSAPP_TARGET_NOT_FOUND:
          "Destination connection not found for this company.",
        ERR_TRANSFER_WHATSAPP_CHANNEL_MISMATCH:
          "Destination connection must use the same channel or be compatible between WhatsApp and Evolution.",
        ERR_TRANSFER_WHATSAPP_SAME_TARGET:
          "Please choose a different connection for transfer.",
      },
      erpPhone: {
        signature: {
          title: "ERP-PHONE Digital Signature",
          document: "Document",
          content: "Content",
          alreadySigned: "Document already signed on {{date}}.",
          expired: "This signing link has expired.",
          invalidToken: "Invalid signing link.",
          signHere: "Sign in the field below:",
          selfie: "Capture/Upload Selfie",
          clear: "Clear",
          sign: "Sign Document",
          saving: "Saving...",
          signatureRequired: "Signature is required.",
          loadError: "Could not load the document.",
          signError: "Failed to sign document.",
          loading: "Loading...",
        },
      },
    },
  },
};

export { messages };
